export default __webpack_public_path__ + "static/media/atza-dark-logo.5fb95e5a.png";